import o from "styled-components";
import { Button as t } from "../../../Inputs/Button/Button.es.js";
const e = o.footer.withConfig({
  displayName: "Footer",
  componentId: "sc-1r77z3y-0"
})(["align-items:center;border-top:1px solid var(--color-gray-light2);display:flex;gap:16px;justify-content:flex-end;min-height:56px;padding:0 24px;"]), p = o(t).withConfig({
  displayName: "CustomButton",
  componentId: "sc-1r77z3y-1"
})(["min-width:104px;"]);
export {
  p as CustomButton,
  e as Footer
};
//# sourceMappingURL=style.es.js.map
